import { render, staticRenderFns } from "./JobCardList.vue?vue&type=template&id=d6e1585a&scoped=true&"
import script from "./JobCardList.vue?vue&type=script&lang=js&"
export * from "./JobCardList.vue?vue&type=script&lang=js&"
import style0 from "./JobCardList.vue?vue&type=style&index=0&id=d6e1585a&lang=scss&scoped=true&"
import style1 from "./JobCardList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e1585a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VChip,VCol,VContainer,VDivider,VIcon,VListItemContent,VListItemIcon,VRow,VSkeletonLoader})
